import { Injectable } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { ConfirmDialogComponent, ConfirmDialogData } from '../dialogs/confirm-dialog/confirm-dialog.component'

export enum Selection {
  Cancel,
  Discard,
  Save,
}

export interface Result {
  selection: Selection
}

@Injectable({
  providedIn: 'root',
})
export class ConfirmService {
  constructor(private dialog: MatDialog) {}

  confirm(headerText: string, contentText: string, saveButtonActive: boolean): Observable<Result> {
    const dialogRef = this.dialog.open<ConfirmDialogComponent, ConfirmDialogData, string>(ConfirmDialogComponent, {
      data: {
        headerText,
        contentText,
        saveButtonActive,
      } as ConfirmDialogData,
      minHeight: '200px',
      height: 'auto',
    })

    // Result is either false or true depending if user wants to delete the data
    return dialogRef.afterClosed().pipe(
      map(selected => {
        let value: Selection

        switch (selected) {
          case 'cancel':
            value = Selection.Cancel
            break
          case 'discard':
            value = Selection.Discard
            break
          case 'save':
            value = Selection.Save
            break
          default:
            value = Selection.Cancel
            break
        }
        return { selection: value } as Result
      }),
    )
  }
}
